import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';
import { ProducerFormData, AVAILABLE_CATEGORIES } from '../types';

interface CategoriesSectionProps {
  formData: ProducerFormData;
  toggleCategory: (category: string) => void;
  addCategory: (category: string) => void;
  onCapabilitySuggestionChange?: (value: string) => void;
}

export function CategoriesSection({
  formData,
  toggleCategory,
  onCapabilitySuggestionChange,
}: CategoriesSectionProps) {
  const hasOther = formData.capabilitySuggestion.length > 0;
  const [otherChecked, setOtherChecked] = useState(hasOther);

  const handleOtherToggle = (checked: boolean) => {
    setOtherChecked(checked);
    if (!checked) {
      onCapabilitySuggestionChange?.('');
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-foreground">Kategorier</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Vad erbjuder gården?
        </p>
      </div>

      <div className="flex flex-wrap gap-2">
        {AVAILABLE_CATEGORIES.map((category) => (
          <button
            key={category}
            type="button"
            onClick={() => toggleCategory(category)}
            className={cn(
              'px-3 py-1.5 rounded-full text-sm font-medium transition-colors border',
              formData.categories.includes(category)
                ? 'bg-primary/15 border-primary/30 text-primary'
                : 'bg-card border-border text-muted-foreground hover:border-primary/30'
            )}
          >
            {category}
          </button>
        ))}
      </div>

      {/* "Något annat" option */}
      <div className="space-y-3">
        <label className="flex items-center gap-2 cursor-pointer">
          <Checkbox
            checked={otherChecked}
            onCheckedChange={(checked) => handleOtherToggle(checked === true)}
          />
          <span className="text-sm text-foreground">Något annat</span>
        </label>

        {otherChecked && (
          <div className="pl-6 space-y-1.5">
            <p className="text-xs text-muted-foreground">
              Saknas något? Berätta gärna så kan vi lägga till det i Farmly.
            </p>
            <Input
              value={formData.capabilitySuggestion}
              onChange={(e) => onCapabilitySuggestionChange?.(e.target.value)}
              placeholder="Beskriv kort…"
              className="max-w-sm"
              maxLength={200}
            />
          </div>
        )}
      </div>
    </div>
  );
}
